(function() {
    'use strict';

    angular.module("imApp").factory("prePaymentService", ['$ihttp', function ($ihttp) {
        let service = {
            getPrepayment: function (parms) {
                return $ihttp.post({
                    method: 465,
                    parameters: parms || {}
                });
            },
            listCashTypePayments: function (parms) {
                return $ihttp.post({
                    method: 466,
                    parameters: parms || {}
                });
            },
            listPaymentPlans: function (parms) {
                return $ihttp.post({
                    method: 2746,
                    parameters: parms || {}
                });
            },
            createObj: function (edit) {
                return $ihttp.post({
                    method: 2638,
                    parameters: edit
                });
            },
            saveObj: function (mergeObj) {
                return $ihttp.post({
                    method: 467,
                    parameters: mergeObj
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 469,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
